import { FormControl, FormLabel, TextField } from "@mui/material";
import { useCallback, useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { cloneDeep, debounce } from "lodash";
import { treeActions } from "../../redux/slices/treeSlice";
import { eachDeep } from "deepdash-es/standalone";
import { useTranslation } from "react-i18next";
// import ErrorModal from "./Forms/FieldDataValidation/ErrorModal";
import { getParentArray } from "./Forms/FieldPropertyForm";
import { t } from "i18next";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

function CommentProperties() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector(
    (state) => state.treeData[parentScreen]
  );
  const selectedNode = useSelector(
    (state) =>
      state.treeData[parentScreen].rightTree.tree[
        rightTree.currentTab
      ].selectedNode
  );
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
  const [comment, setComment] = useState("");
  // const [commentName, setCommentName] = useState("");
  // const [errorModal,setErroModal] = useState(false);
  // const [errorMessage,setErrorMessage] = useState('');

  const submitChange = (key, val) => {
    // if (selectedNode?.type === "COMMENT") {
      // let duplicateName;
      const parentArray = getParentArray(
        selectedNode.key.split("-").slice(0, -1).join("-"),
        translatedData
      );

      if (val && key==='COMMENT_NAME') {
          parentArray.forEach((ele) => {
            
          if (
            ele.key !== selectedNode.key && 
            ((ele.ICON_DISPLAY === "COMMENT" && ele.COMMENT_NAME === val) || (ele.MAPNAME === val))
          ) {
            // console.log("duplicate",ele);
            // duplicateName = true;
          }
        });
      }
      dispatch(
        treeActions.setNewRightTreeTranslatedData({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: eachDeep(
            cloneDeep(rightTree.tree[rightTree.currentTab].translatedData),
            (objValue) => {
              if (objValue?.key === selectedNode?.key) {
                if (key === "COMMENT") {
                  objValue.title = `${t('LBL_COMMENT')} ${val}`
                  objValue['COMMENT'] = (val);
                }
                // if (key === "COMMENT_NAME") {
                //   if(duplicateName){
                //     setErroModal(true);
                //     setCommentName(objValue.COMMENT_NAME);
                //     setErrorMessage(t("BOX_INBOUND_FIELD_NAME_ALREADY_EXISTS").replace("{0}",val));
                //     return;
                //   }  
                //   objValue.title = val;
                //   objValue.MAPNAME = val;
                //   objValue.COMMENT_NAME = val;
                // }

                // dispatch(
                //   treeActions.setRightTreeSelectedNode(
                //     cloneDeep({
                //       screen: parentScreen,
                //       type: rightTree.currentTab,
                //       data: objValue,
                //     })
                //   )
                // );
              }
            }
          ),
        })
      );
    // }
  };

  // const validateComment =()=>{
  //   if(!commentName){
  //       const parentArray = getParentArray(
  //           selectedNode.key.split("-").slice(0, -1).join("-"),
  //           translatedData
  //       );
  //       const newCommentName = getCommentName(parentArray);
  //       setCommentName(newCommentName);
  //       debounceChangeHandler("COMMENT_NAME",newCommentName)
  //   }
  // }


  const debounceChangeHandler = useCallback(debounce(submitChange, 500), [
    rightTree.currentTab,
    rightTree.tree,
  ]);

  useEffect(() => {
    // setCommentName(selectedNode?.COMMENT_NAME || '');
    setComment((selectedNode?.COMMENT));
  }, [selectedNode]);

  return (
    <div className="height-100 padding-12">
      <div className={"height-100"}>
        <div>
          {/* <FormControl className="width-100" size="small">
            <TextField
              variant="outlined"
              size="small"
              type="text"
              autoComplete="off"
              label={t("NAME_")}
              value={commentName || ''}
              className={"width-100"}
              onChange={(e) => {
                setCommentName(e.target.value);
                debounceChangeHandler("COMMENT_NAME", e.target.value);
              }}
              onBlur={validateComment}
            />
          </FormControl> */}
          <FormControl
            className="width-100"
            size="small"
            sx={{ marginTop: "1rem" }}
          >
            <FormLabel>{t("LBL_COMMENT")}</FormLabel>
            <TextField
              className="text-field-scroll width-100"
              //commented out this code due to an issue with unintended clipboard 
              // content getting pasted because of auto-focus.
             // autoFocus={true} 
              multiline={true}
              rows={10}
              size="medium"
              type="text"
              value={comment || ''}
              onChange={(e) => {
                setComment(e.target.value);
                debounceChangeHandler("COMMENT", e.target.value);
              }}
            />
          </FormControl>
        </div>
      </div>
      {/* <ErrorModal errorModal={errorModal} errorMessage={errorMessage} handleErrorModal={setErroModal}/> */}
    </div>
  );
}

export default CommentProperties;

export const getCommentName = (parentArray) => {
  const data = cloneDeep(parentArray);
  let prevCommentNumber = null;

  const getMapName = (data) => {
    data.forEach((ele) => {
      const name = ele.COMMENT_NAME;
      if (name && name.startsWith(t("COMMENT"))) {
        prevCommentNumber =prevCommentNumber === null ? 0 : prevCommentNumber
        const firstOccurance = name.indexOf(t("COMMENT"));
        const startingBracket = name.indexOf("(");
        const endingBracket = name.indexOf(")");

        if (
          startingBracket >= 0 &&
          endingBracket >= 0 &&
          endingBracket > startingBracket &&
          endingBracket - startingBracket + t("COMMENT").length >= 1 &&
          startingBracket - (firstOccurance + t("COMMENT").length - 1) ===
            2
        ) {
            // console.log("reached");
          const commentNumber = name.substring(
            startingBracket + 1,
            endingBracket
          );
          
          if(!isNaN(commentNumber)){
            prevCommentNumber = Number(prevCommentNumber) <= Number(commentNumber) ? Number(commentNumber)  : prevCommentNumber;
          }  

        }
      }
      if (ele?.children?.length > 0) {
        getMapName(ele.children);
      }
    });
  };

  getMapName(data);
//   console.log(prevCommentNumber);
  return `${t("COMMENT")} ${prevCommentNumber !==null ? `(${Number(prevCommentNumber + 1)})`: ""}`;
};
